module.exports = __webpack_public_path__ + "static/media/main.523b98f2.png";